module.exports = function () {

    let module = {};

    let maps = [
        'map-container',
        'map-container-2'
    ];

    let map;
    let marker;

    // Declare image dimensions
    let marker_size = [42 * 2, 57 * 2];

    module.init = function ($map_id) {

        // Work out which options to choose
        // If a class is present use those options
        // otherwise use default


        var options = {
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: false,
            styles:
                [
                    {
                        "featureType": "all",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#0C2429" // Dark teal as the base map background
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "gamma": 0.01
                            },
                            {
                                "lightness": 20
                            },
                            {
                                "weight": "1.39"
                            },
                            {
                                "color": "#FFFFFF" // White text for maximum contrast and clarity
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "weight": "0.96"
                            },
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#1F343A" // Subtle dark gray stroke to outline text
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off" // No icons for a clean, minimalist look
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 15
                            },
                            {
                                "saturation": -10
                            },
                            {
                                "color": "#1F343A" // Dark muted gray-teal for landscapes
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "saturation": -20
                            },
                            {
                                "lightness": 10
                            },
                            {
                                "color": "#294046" // Subtle, desaturated green-teal for points of interest
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 0
                            },
                            {
                                "saturation": -30
                            },
                            {
                                "color": "#0C2429" // Match parks with the dark base teal for seamless integration
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": -5
                            },
                            {
                                "saturation": -50
                            },
                            {
                                "color": "#1F343A" // Neutral dark gray for road geometry
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#294046" // Muted green-gray for road fills
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "saturation": -30
                            },
                            {
                                "lightness": -10
                            },
                            {
                                "weight": "0.5"
                            },
                            {
                                "color": "#98CA3E" // Primary brand green for road strokes
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "lightness": -20
                            },
                            {
                                "color": "#0A1E24" // Very dark blue-gray for water to blend with the overall theme
                            }
                        ]
                    }
                ]


        };

        if ($('#' + $map_id).length) map = new google.maps.Map(document.getElementById($map_id), options);


        var image = {
            url: '/images/mapmarker.png',
            size: new google.maps.Size(marker_size[0], marker_size[1]),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, marker_size[1] / 2),
            scaledSize: new google.maps.Size(marker_size[0] / 2, marker_size[1] / 2)
        };

        marker = new google.maps.Marker({
            map: map,
            animation: google.maps.Animation.DROP,
            icon: image,
            optimized: false

        });


        // Resize stuff...
        google.maps.event.addDomListener(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });

    };

    module.assign = function () {


        $.each(maps, function (index, value) {


            let $map_id = value;

            if ($('#' + $map_id).length) {


                module.init($map_id);

                $lat = $('#' + $map_id).data('lat');
                $lng = $('#' + $map_id).data('long');
                $zoom = $('#' + $map_id).data('zoom');

                // JSON array of map data
                $json = $('#' + $map_id).data('json');


                var image = {
                    url: '/images/mapmarker.png',
                    size: new google.maps.Size(marker_size[0], marker_size[1]),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(20, marker_size[1] / 2),
                    scaledSize: new google.maps.Size(marker_size[0] / 2, marker_size[1] / 2)
                };


                // Array of placemarkers in JSON format

                if ($json) {
                    var points = $json;

                    //create empty LatLngBounds object
                    var bounds = new google.maps.LatLngBounds();
                    var infowindow = new google.maps.InfoWindow();
                    let zoom;
                    let loc;

                    $.each(points, function ($k, $v) {

                        loc = new google.maps.LatLng($v.latitude, $v.longitude);

                        zoom = $v.map_zoom;

                        marker = new google.maps.Marker({
                            map: map,
                            animation: google.maps.Animation.DROP,
                            icon: image,
                            url: $v.url,
                            position: loc,
                            title: $v.title
                        });

                        //extend the bounds to include each marker's position
                        bounds.extend(marker.position);

                        google.maps.event.addListener(marker, 'click', (function (marker, $k) {
                            return function () {
                                infowindow.setContent($v.infowindow_content);
                                infowindow.open(map, marker);
                            }
                        })(marker, $k));

                        marker.setPosition(loc);
                    });

                    if (points.length > 1) {

                        // Set a maxZoom before fitting bounds
                        map.setOptions({maxZoom: 11});

                        //now fit the map to the newly inclusive bounds
                        map.fitBounds(bounds);

                    } else {

                        marker.setPosition(loc);
                        map.setCenter(loc);
                        map.setZoom(zoom ? zoom : 10);
                    }


                }
                // Single point
                else {

                    var location = new google.maps.LatLng($lat, $lng);
                    google.maps.event.trigger(map, 'resize');
                    marker.setPosition(location);
                    map.setCenter(location);
                    map.setZoom($zoom);
                }
            }


        });


    };

    return module;

};
